import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src", "alt"]

import { computed } from 'vue'

import Button from '@/components_new/Button.vue'
import Typography from '@/components_new/Typography.vue'
import { useTr } from '@/composables/use-tr'
import { OutOfPageAdType } from '@/modules/adv'

import imgBackpack from './images/img-backpack.webp'
import imgBall from './images/img-ball.webp'
import imgGum from './images/img-gum.webp'
import imgHeart from './images/img-heart.webp'
import imgPigeon from './images/img-pigeon.webp'

interface Props {
    adType: OutOfPageAdType | null
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ErrorState',
  props: {
    adType: {}
  },
  setup(__props: any) {

const tr = useTr()



const label = computed(() => (__props.adType === 'rewarded' ? tr('brandPreloader.reward') : tr('brandPreloader.adSkipped')))

const randomImage = computed(() => {
    const images = [imgBackpack, imgBall, imgGum, imgHeart, imgPigeon]
    return images[Math.floor(Math.random() * images.length)]
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style.wrapper),
    "data-interface-section": "brand-preloader-error-state"
  }, [
    _createElementVNode("img", {
      src: randomImage.value,
      alt: label.value,
      class: _normalizeClass([_ctx.$style.image, _ctx.$style.image_animated])
    }, null, 10, _hoisted_1),
    _createVNode(Typography, {
      type: "label",
      size: "l",
      class: _normalizeClass(_ctx.$style.label)
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(label.value), 1)
      ]),
      _: 1
    }, 8, ["class"]),
    _createVNode(Button, {
      size: "m",
      interfaceTarget: "brand-preloader-continue-button"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$tr('brandPreloader.continuePlaying')), 1)
      ]),
      _: 1
    })
  ], 2))
}
}

})